import script from "./msSelectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./msSelectBox.vue?vue&type=script&setup=true&lang=js"

import "./msSelectBox.vue?vue&type=style&index=0&id=fdc012ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdc012ee"]])

export default __exports__